import { Badge } from './ui/badge';

/**
 * Badge mapping for the 7 booking payment states returned by
 * booking_payment_state.py on the backend.
 */
const STATE_CONFIG = {
  Paid: {
    className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400 border-0',
  },
  'Partially paid': {
    className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400 border-0',
  },
  Pending: {
    className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400 border-0',
  },
  Unpaid: {
    className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400 border-0',
  },
  'Not due': {
    className: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border-0',
  },
  'No feed': {
    className: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400 border-0',
  },
  'Owner-collected': {
    className: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400 border-0',
  },
};

export function PayoutStateBadge({ state, className = '' }) {
  if (!state) {
    return (
      <Badge variant="outline" className={`text-[10px] px-1 py-0 text-muted-foreground ${className}`}>
        Unknown
      </Badge>
    );
  }
  const config = STATE_CONFIG[state];
  if (!config) {
    return (
      <Badge variant="outline" className={`text-[10px] px-1 py-0 ${className}`}>
        {state}
      </Badge>
    );
  }
  return (
    <Badge className={`text-[10px] px-1 py-0 ${config.className} ${className}`}>
      {state}
    </Badge>
  );
}
